import { useListContext } from "ra-core";
import { Fragment } from "react";
import { compareByDate } from "@/lib/safeDate";
import { Separator } from "@/components/ui/separator";

import { Note } from "./Note";
import { NoteCreate } from "./NoteCreate";
import { InfinitePagination } from "../misc/InfinitePagination";

export const NotesIterator = ({
  reference,
  showStatus,
}: {
  reference: "contacts" | "deals";
  showStatus?: boolean;
}) => {
  const { isPending, error, data = [] } = useListContext();
  const notes = [...data].sort((a, b) => compareByDate(a.date, b.date));

  // A background refetch can fail after the notes are already on screen.
  // Hiding them then makes a saved note look like it vanished.
  if (notes.length === 0 && (isPending || error)) return null;

  return (
    <div className="mt-4">
      <NoteCreate
        reference={reference}
        showStatus={showStatus}
        className="rounded-row border border-dashed border-line-strong p-3"
      />
      {notes.length > 0 && (
        <div className="mt-4 space-y-4">
          {notes.map((note, index) => (
            <Fragment key={note.id}>
              <Note
                note={note}
                isLast={index === notes.length - 1}
                showStatus={showStatus}
              />
              {index < notes.length - 1 && <Separator />}
            </Fragment>
          ))}
        </div>
      )}
      <InfinitePagination />
    </div>
  );
};
